import React, { useEffect, useState } from 'react'
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  FunctionField,
  useTranslate,
  useResourceContext,
  useResourceDefinitions,
  useListController,
  useStore,
  BooleanInput,
} from 'react-admin'
import { Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ListViewActionsButtons } from 'src/components/uiElements/buttons/ListViewActionsButtons'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'

export const WorkUnitList = (props) => {
  const translate = useTranslate()
  const { setSort, isFetching } = useListController()
  const [isSorting, setIsSorting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [permissionsStore, setPermissionsStore] = useStore('currentResource', '{}')
  const [permissions, setPermissions] = useState(null)
  const propsResource = useResourceDefinitions()
  const resourceName = useResourceContext()

  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[resourceName]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, resourceName])

  useEffect(() => {
    if (permissionsStore) {
      setPermissions(JSON.parse(permissionsStore))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsStore])

  useEffect(() => {
    if (isSorting && isFetching) {
      setIsLoading(true)
    } else if (isLoading && isSorting && !isFetching) {
      setIsLoading(false)
      setIsSorting(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSorting, isFetching])

  const onClickSort = (sort) => {
    setSort(sort)
    setIsSorting(true)
  }

  const hasPermissions = () => {
    return permissions?.options?.revision ||
      permissions?.hasShow ||
      permissions?.hasEdit ||
      permissions?.options?.delete
  }

  const workUnitFilters = [
    <TextInput label={translate('ra.field.id')} source='id' defaultValue='' />,
    <TextInput label={translate('ra.field.short_name')} source='short_name' defaultValue='' />,
    <TextInput label={translate('ra.field.long_name')} source='long_name' defaultValue='' />,
    <TextInput label={translate('ra.field.parent_id')} source='parent_id' defaultValue='' />,
    <BooleanInput label={translate('ra.field.is_active')} source='is_active' defaultValue={true} />,
  ]

  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.work-unit')}>
        <List {...props}
          component='div'
          filters={workUnitFilters}
          filter={{ listing : true }}
          actions={<ListViewTopToolbar hasCreate={permissions?.hasCreate}/>}
        >
          <Datagrid rowClick='show' setSort={onClickSort} isLoading={isLoading}>
            <TextField source='id' label={translate('ra.field.id')} />
            <TextField source='short_name' label={translate('ra.field.short_name')} />
            <TextField source='long_name' label={translate('ra.field.long_name')} />
            <TextField source='description' label={translate('ra.field.description')} />
            <TextField source='parent_relation.long_name' label={translate('ra.field.parent_workunit')} />
            <FunctionField
              label={translate('ra.field.product')}
              render={(record) => {
                let string_with_products = ''
                // loop through the long names and concatenate them
                record?.product_by_work_unit_relation?.forEach(
                  (product) => (string_with_products += product?.product_relation?.long_name + ', ')
                )
                // remove the comma
                const removedLast2 = string_with_products.slice(0, -2)
                return removedLast2 ? removedLast2 : '-'
              }}
            />
            {hasPermissions() && (
              <ListViewActionsButtons labelHeader={translate('ra.action.actions')} fieldsName={['short_name']} genderElement='femenine' />
            )}
          </Datagrid>
        </List>
      </CardCommon>
    </Container>
  )
}
